import { CSSObject } from '@chakra-ui/react';

export const FormWrapper: CSSObject = {
  fontSize: 'xs',
  'button[data-cy="promotionsPreferencesSubmit"]': {
    w: '125px',
    textTransform: 'uppercase',
  },
};

export const TextS: CSSObject = {
  fontSize: 'xs',
};

export const ButtonSaveChanges: CSSObject = {};
